/**
 * Mixin za warehouse boje i kalkulacije količina
 */
export default {
    methods: {
        /**
         * Određuje boju za stock kolonu
         * @param {Object} item - Warehouse item
         * @returns {string} - Hex boja ili naziv boje
         */
        getStockColor(item) {
            return item.stock < item.quantity ? "yellow" : "#86df86";
        },

        /**
         * Izračunava količinu nakon akcije (naručivanje/izdavanje)
         * @param {Object} item - Warehouse item
         * @returns {string} - Količina formatirano sa 3 decimale
         */
        calculateAfterActionQuantity(item) {
            const stock = parseFloat(item.stock || 0);
            const order = parseFloat(item.order || 0);

            let result;
            if (this.stockType === "ordered") {
                result = stock + order;
            } else if (this.stockType === "exit") {
                result = stock - order;
            } else {
                result = stock;
            }

            return this.formatQuantity(result);
        },

        /**
         * Određuje boju za "količina nakon akcije" kolonu
         * @param {Object} item - Warehouse item
         * @returns {string} - Hex boja ili 'transparent'
         */
        getAfterActionColor(item) {
            const order = parseFloat(item.order || 0);

            // Ako nije unesena količina za naručivanje/izdavanje, ne bojimo
            if (order === 0) {
                return "transparent";
            }

            const afterActionQty = parseFloat(this.calculateAfterActionQuantity(item));
            const requiredQty = parseFloat(item.quantity || 0);

            return afterActionQty < requiredQty ? "yellow" : "#86df86";
        },
    },
};
